<template>
  <component :is="component" :filterData="filterData" v-if="component" :areaList="areaList" />
</template>

<script>
export default {
name: "MemberFilterLink",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    filterLayout: '',
    filterData: {
      default: {}
    },
    areaList:{
      type: Array,
      default: () => {return []}
    },

  },
  data() {
    return {
      component: null
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/member/filter/MemberFilterDefaultLayout');
        })
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader(){
      if(!this.filterLayout){
        return null;
      }
      return () => import(`@/template/member/filter/${this.filterLayout}`);
    }
  },
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>